import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class NGOrganizationsService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }

  GetNGOrganizationsPaged(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/NGOrganization/GetPaged`,data);
  }
  GetNGOrganizationsById(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/NGOrganization/GetById?Id=${id}`);
  }
}
